import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivity = ({ activities }) => {
  const getActivityIcon = (type) => {
    const iconMap = {
      'ticket_sale': 'Ticket',
      'event_created': 'Calendar',
      'venue_added': 'MapPin',
      'merchandise_sale': 'Package',
      'team_invite': 'UserPlus',
      'report_generated': 'FileText',
      'scanner_access': 'QrCode'
    };
    return iconMap?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colorMap = {
      'ticket_sale': 'text-success',
      'event_created': 'text-primary',
      'venue_added': 'text-accent',
      'merchandise_sale': 'text-warning',
      'team_invite': 'text-secondary',
      'report_generated': 'text-muted-foreground',
      'scanner_access': 'text-primary'
    };
    return colorMap?.[type] || 'text-muted-foreground';
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const time = new Date(timestamp);
    const diffInMinutes = Math.floor((now - time) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays}d ago`;
    
    return time?.toLocaleDateString();
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm">
      <div className="p-6 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        <p className="text-sm text-muted-foreground">Latest updates from your events and team</p>
      </div>
      <div className="p-6">
        {activities?.length > 0 ? (
          <div className="space-y-4">
            {activities?.map((activity) => (
              <div key={activity?.id} className="flex items-start space-x-3">
                <div className={`w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
                  <Icon name={getActivityIcon(activity?.type)} size={16} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-medium text-foreground">{activity?.title}</p>
                    <span className="text-xs text-muted-foreground">{formatTimeAgo(activity?.timestamp)}</span>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1">{activity?.description}</p>
                  {activity?.metadata && (
                    <div className="flex items-center space-x-4 mt-2">
                      {activity?.metadata?.amount && (
                        <span className="text-xs font-medium text-success">
                          +${activity?.metadata?.amount}
                        </span>
                      )}
                      {activity?.metadata?.event && (
                        <span className="text-xs text-muted-foreground">
                          {activity?.metadata?.event}
                        </span>
                      )}
                      {activity?.metadata?.user && (
                        <span className="text-xs text-muted-foreground">
                          by {activity?.metadata?.user}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <Icon name="Activity" size={48} className="text-muted-foreground mx-auto mb-4" />
            <h4 className="text-lg font-medium text-foreground mb-2">No recent activity</h4>
            <p className="text-muted-foreground">
              Activity from your events and team will appear here
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;